import { z } from "zod";

export const CONCIERGE_PRODUCT_KNOWLEDGE_MAX_LENGTH = 2000;

export const ConciergeProductKnowledgeParser = z
  .string()
  .max(CONCIERGE_PRODUCT_KNOWLEDGE_MAX_LENGTH);
